import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { redirectFor } from "@/lib/seo-redirects";

/**
 * Catch-all for URLs that are not part of the site.
 *
 * Legacy URLs in the SEO redirect map get one permanent hop to their live
 * destination (no chains, no homepage catch-all). Everything else must answer
 * with a real HTTP 404 plus `noindex`: redirecting every unknown URL to `/`
 * makes Google report "Page with redirect" and "Duplicate without
 * user-selected canonical" for thousands of bogus URLs. Near-miss dynamic URLs
 * (unknown guide slug, unknown Pal slug, ...) still redirect to their parent
 * index inside those routes.
 */
export const Route = createFileRoute("/$")({
  beforeLoad: ({ location }) => {
    const to = redirectFor(location.pathname);
    if (to) throw redirect({ href: to, statusCode: 301 });
    throw notFound();
  },

  head: () => ({
    meta: [
      { title: "Page not found — Pal Stars" },
      { name: "description", content: "This page does not exist on Pal Stars." },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});
